import React, { useRef, useState, useEffect } from "react";
import { InfoCircleOutlined, LeftOutlined, RightOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { Tooltip } from "react-tooltip"; // ✅ Correct import for v5+
import "react-tooltip/dist/react-tooltip.css"


const PaymentTiles = ({
    paymentBalances,
    setSelectedPaymentMethod,
    selectedPaymentMethod,
    bankAccounts,
}) => {

    console.log("bankAccounts ------>", bankAccounts);

    const scrollRef = useRef(null);
    const [showLeft, setShowLeft] = useState(false);
    const [showRight, setShowRight] = useState(true);

    const { t, i18n } = useTranslation();
    const isRTL = i18n.language === "ar";

    const scroll = (direction) => {
        if (scrollRef.current) {
            const { clientWidth } = scrollRef.current;
            const scrollAmount = direction === "left" ? -clientWidth : clientWidth;
            const adjustedScroll = isRTL ? -scrollAmount : scrollAmount;

            scrollRef.current.scrollBy({
                left: adjustedScroll,
                behavior: "smooth",
            });
        }
    };

    const checkScroll = () => {
        const el = scrollRef.current;
        if (!el) return;

        const tolerance = 5;
        const scrollLeft = isRTL ? Math.abs(el.scrollLeft) : el.scrollLeft;

        setShowLeft(scrollLeft > tolerance);
        setShowRight(scrollLeft + el.clientWidth < el.scrollWidth - tolerance);
    };

    useEffect(() => {
        checkScroll();

        const el = scrollRef.current;
        if (!el) return;

        el.addEventListener("scroll", checkScroll);
        window.addEventListener("resize", checkScroll);

        return () => {
            el.removeEventListener("scroll", checkScroll);
            window.removeEventListener("resize", checkScroll);
        };
    }, [paymentBalances, isRTL]);

    const handleTileClick = (paymentMethod) => {
        setSelectedPaymentMethod(paymentMethod);
    };

    return (
        <div className="relative group">
            {/* Left Arrow (visually left in LTR, right in RTL) */}
            {showLeft && (
                <button
                    onClick={() => scroll("left")}
                    className={`absolute top-1/2 -translate-y-1/2 bg-white/70 hover:bg-white border rounded-full shadow-md p-2 z-10 opacity-0 group-hover:opacity-100 transition
          ${isRTL ? "right-0" : "left-0"}`}
                >
                    {/* Reverse icon direction for RTL */}
                    {isRTL ? <RightOutlined /> : <LeftOutlined />}
                </button>
            )}

            {/* Scrollable Tiles */}
            <div
                ref={scrollRef}
                dir={isRTL ? "rtl" : "ltr"}
                className="flex overflow-x-auto gap-4 ps-0 pr-4 pb-4 pt-2 hide-scrollbar scroll-smooth"
            >
                {paymentBalances.map((item, index) => {
                    const isSelected = selectedPaymentMethod === item.payment_method;

                    return (
                        <div
                            key={index}
                            onClick={() => handleTileClick(item.payment_method)}
                            className={`relative flex-shrink-0 flex flex-col text-gray-800 border rounded-md px-6 py-3 shadow-sm min-w-[180px] cursor-pointer group/tile
                transition-all duration-200
                ${isSelected
                                    ? "bg-[#E3F2FD] border-primaryBlue shadow-lg"
                                    : "bg-white border-gray-300 hover:bg-[#E3F2FD] hover:shadow-lg"
                                }`}
                        >
                            {/* Info Icon (only for Bank) */}
                            {item.payment_method === "Bank" && (
                                <>
                                    <InfoCircleOutlined
                                        id={`bank-tooltip-target-${index}`}
                                        className="absolute top-2 right-2 text-primary cursor-pointer text-lg duration-200"
                                    />

                                    <Tooltip
                                        anchorSelect={`#bank-tooltip-target-${index}`}
                                        place="top"
                                        positionStrategy="fixed"

                                        style={{
                                            backgroundColor: "#fff",
                                            color: "#333",
                                            borderRadius: "10px",
                                            padding: "12px 16px",
                                            boxShadow: "0 4px 14px rgba(0, 0, 0, 0.15)",
                                            maxWidth: "340px",
                                            textAlign: "left",
                                            fontSize: "13px",
                                            zIndex: 999999,
                                            whiteSpace: "normal",
                                            lineHeight: "1.5",
                                            overflowY: bankAccounts.length > 4 ? "auto" : "visible",
                                            maxHeight: bankAccounts.length > 4 ? "220px" : "none", // 👈 adjusts height dynamically
                                            scrollbarWidth: "thin",
                                            scrollbarColor: "#ccc transparent",
                                        }}
                                        className="custom-bank-tooltip"

                                    >
                                        {bankAccounts.length > 0 ? (
                                            bankAccounts.map((account, idx) => (
                                                <div
                                                    key={idx}
                                                    className="py-1 border-b border-gray-200 last:border-0"
                                                    style={{ paddingBottom: "6px" }}
                                                >
                                                    <strong style={{ display: "block", color: "#111" }}>
                                                        {account.bank_name}
                                                    </strong>
                                                    <span style={{ color: "#555" }}>
                                                        <strong>{t("Balance")}:</strong> EGP {Number(account.balance).toFixed(2)}
                                                    </span>
                                                </div>
                                            ))
                                        ) : (
                                            <div className="text-gray-500 text-sm">{t("No bank accounts available")}</div>
                                        )}
                                    </Tooltip>
                                </>
                            )}

                            <span
                                // className="text-sm font-medium ms-2"
                                className={`text-sm font-medium ${i18n.language === 'ar' ? 'ms-2' : ''
                                    }`}
                            >
                                {t(item.payment_method)}
                            </span>
                            <span className="text-xl font-bold">
                                EGP {Number(item.balance).toFixed(2)}
                            </span>
                        </div>
                    );
                })}
            </div>

            {/* Right Arrow (visually right in LTR, left in RTL) */}
            {showRight && (
                <button
                    onClick={() => scroll("right")}
                    className={`absolute top-1/2 -translate-y-1/2 bg-white/70 hover:bg-white border rounded-full shadow-md p-2 z-10 opacity-0 group-hover:opacity-100 transition
          ${isRTL ? "left-0" : "right-0"}`}
                >
                    {/* Reverse icon direction for RTL */}
                    {isRTL ? <LeftOutlined /> : <RightOutlined />}
                </button>
            )}
        </div>
    );
};

export default PaymentTiles;
